import {ssrLazy} from 'ssr/lazy';

export const ProductHighlightLazy = ssrLazy(() => import(/* webpackChunkName: "productHighlight" */ '.'));
